import { animate, state, style, transition, trigger } from '@angular/animations';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkOverlayOrigin, OverlayModule, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { Navmenu } from 'app/core/models/nav-menu.model';
import { provideGtmEvent, ShebaGtmClickDirective, ShebaGtmEventDirective } from 'app/core/services/google-tag-manager/gtm.directive';
import { ArrowDownIcon } from 'assets/icons/arrow-down/arrow-down';
import { ShebaArrowStickSmallIcon } from './arrow-stick';
import { SanitizeUrlPipe } from 'app/core/pipes/sanitize-url.pipe';

@Component({
  selector: 'sheba-headernav',
  exportAs: 'headernav',
  imports: [
    OverlayModule,
    A11yModule,
    NgClass,
    MatRippleModule,
    ArrowDownIcon,
    RouterLinkDetectorDirective,
    ShebaGtmClickDirective,
    ShebaGtmEventDirective,
    ShebaArrowStickSmallIcon,
    SanitizeUrlPipe
  ],
  providers: [
    provideGtmEvent({
      event: 'menu_clicks'
    })
  ],
  animations: [
    trigger('openClose', [
      state(
        '*',
        style({
          opacity: 1,
          height: '*'
        })
      ),
      state(
        'void',
        style({
          opacity: 0.0,
          transform: 'translateY(-10%)'
        })
      ),
      transition('* => void', [animate('100ms')]),
      transition('void => *', [animate('150ms')])
    ])
  ],
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './headernav.component.html',
  styleUrl: './headernav.component.scss'
})
export class ShebaHeadernavComponent {
  menu = input<Navmenu[] | undefined>([] as Navmenu[]);

  overlayOrigin = input.required<CdkOverlayOrigin>();

  blockScrollStrategy = inject(ScrollStrategyOptions).block();

  activeMenuIndex = signal(0);
  activeIndex = signal(0);

  isOpen = signal(false);

  onMenuButtonClick(index: number): void {
    this.activeIndex.set(0);
    if (this.activeMenuIndex() === index) {
      this.isOpen.set(!this.isOpen());
      return;
    }

    this.activeMenuIndex.set(index);
    this.isOpen.set(true);
  }

  get itemsCount(): number {
    return this.menu()?.[this.activeMenuIndex()]?.children?.length ?? 0;
  }

  constructor() {
    effect(() => {
      if (this.isOpen()) {
        this.blockScrollStrategy.enable();
      } else {
        this.blockScrollStrategy.disable();
      }
    });
  }
}
